export var LogLevel;

(function (LogLevel) {
  LogLevel[LogLevel["NONE"] = 0] = "NONE";
  LogLevel[LogLevel["LOG"] = 1] = "LOG";
  LogLevel[LogLevel["DEBUG"] = 2] = "DEBUG";
  LogLevel[LogLevel["INFO"] = 4] = "INFO";
  LogLevel[LogLevel["WARN"] = 8] = "WARN";
  LogLevel[LogLevel["ERROR"] = 16] = "ERROR";
})(LogLevel || (LogLevel = {}));